import { InjectionToken } from '@angular/core';

/**
 * Minimal contract exposed by an `appColumnDef` so that header-cell
 * descendants (e.g. `app-sort-header`) can infer the column id without
 * pulling in the full `AppColumnDefDirective` symbol.
 *
 * Mirrors the shape consumed by `MAT_SORT_HEADER_COLUMN_DEF` for
 * backward compatibility with the existing `app-sort-header` (DEV-798).
 */
export interface AppTableColumnDef {
  readonly name: string;
}

/**
 * Injection token provided by `AppColumnDefDirective`. Allows nested directives
 * (sort header, future cell decorators) to read the column name without
 * a hard dependency on the column-def class.
 */
export const APP_TABLE_COLUMN_DEF = new InjectionToken<AppTableColumnDef>(
  'APP_TABLE_COLUMN_DEF'
);
